import { useCallback } from 'react'
import useAnalyticsContext from 'src/analytics/useAnalyticsContext'
import { ChurnSurveyReason } from 'src/models/organizations.models'
import { usePostChurnSurvey } from 'src/queries/organizations/saas.queries'

export function useChurnSurveySubmit(
  orgId: string | undefined,
  analyticsSource?: string,
) {
  const { analytics } = useAnalyticsContext()
  const { mutate: postChurnSurvey } = usePostChurnSurvey()

  return useCallback(
    (
      reason?: ChurnSurveyReason,
      comment?: string,
      additionalComment?: string,
    ): void => {
      if (!orgId) return
      const trimmedComment = comment?.trim() || undefined
      const trimmedAdditionalComment = additionalComment?.trim() || undefined
      analytics.track('churn survey', {
        action: 'completed',
        ...(analyticsSource ? { source: analyticsSource } : {}),
        reason,
        ...(trimmedComment ? { inline_comment: trimmedComment } : {}),
        ...(trimmedAdditionalComment
          ? { additional_comment: trimmedAdditionalComment }
          : {}),
      })
      postChurnSurvey({
        orgId,
        body: {
          reason,
          comment: trimmedComment,
          additionalComment: trimmedAdditionalComment,
        },
      })
    },
    [orgId, postChurnSurvey, analytics, analyticsSource],
  )
}
